import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { useTheme } from '@mui/material';

const AdobeIcon: React.FC<IconProps> = ({ size, style, color, secondaryColor }) => {
  const theme = useTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Adobe"
      role="img"
      style={style}
      width={size ?? '24px'}
      height={size ?? '24px'}
      viewBox="0 0 80 80"
      data-testid="adobe-icon"
    >
      <path fill={color ?? '#FA0C00'} d="M0 0h80v80H0z" />
      <g fill={color ? secondaryColor || theme.palette.primary.main : '#fff'}>
        <path d="M32.46 14.34H11v51.33l21.46-51.33ZM47.56 14.34h21.43v51.33L47.56 14.34ZM40.01 33.25l13.66 32.41h-8.96l-4.08-10.32h-10l9.38-22.09Z" />
      </g>
    </svg>
  );
};
export default AdobeIcon;
